import LinearProgress from '@material-ui/core/LinearProgress';
import { createStyles, withStyles } from '@material-ui/core/styles';

const BorderLinearProgress = withStyles(theme =>
    createStyles({
        root: {
            height: 10,
            borderRadius: 5,
        },
        colorPrimary: {
            backgroundColor: '#F0F2F6',
        },
        bar: {
            borderRadius: 5,
            backgroundColor: '#1D8A8B',
        },
    }),
)(LinearProgress);

export default BorderLinearProgress;
